import { createI18nText } from '@hilma/netina2all';

const howItWorksText = createI18nText({
    he: {
        hiw: 'איך זה עובד?',
        steps: {
            kit: {
                title: 'בוחרים סוג משלוח',
                paragraph: 'בוחרים משלוח מנות מתוך מגוון המשלוחים השונים',
            },
            associations: {
                title: 'בוחרים עמותה לה אתה מעוניין לתרום',
                paragraph: `כל הרווח ממכירת המשלוח יועבר במלואו לעמותה שנבחרה.
                ניתן לבחור לחלק את התרומה באופן שווה בין העמותות המשתתפות במיזם.
                אין הוצאות שכר או אחרות לחברי העמותה.`
            },
            distributionStations: {
                title: 'בוחרים תחנת חלוקה לאיסוף המשלוח',
                paragraph: `לקראת חג הפורים יפעלו ברחבי הארץ מספר רב של מוקדים בהם ניתן לקבל את משלוחי המנות.
                עליכם לבחור את התחנה הנוחה ביותר עבורכם.
                * השנה לא תתאפשר אפשרות למשלוח עד הבית בשל רצון להפנות את מירב תשומת הלב לתחנות החלוקה.
                לנוחיותכם, הוספנו מספר רב של תחנות חלוקה על מנת להקל על איסוף המשלוחים.`,
                linkTitle: 'לרשימת תחנות החלוקה המלאה'
            },
            payment: {
                title: 'תשלום',
                paragraph: `התשלום יתבצע בעזרת כרטיס אשראי באתר מאובטח.
                אנו מתחייבים לא להעביר את שמכם ופרטיכם לאף גורם חיצוני.`
            }
        },
        kosher: <>משלוחי המנות בתחנות החלוקה מגיעים סגורים לחלוטין, לא ניתן לבחור או להחליף.<br /> במידה וקיימת בעיה מהותית ניתן ליצור קשר באתר.<br />
            (תחנת החלוקה אינה אחראית על משלוחי המנות ותפקידה לעזור בחלוקת משלוחי המנות בלבד)</>,
        aboutNet: <><p>לאור ההצלחה בנתינת לולב החלטנו לצאת במיזם דומה סביב חג הפורים,</p>
            <p> מיזם "מתנות קטנות" הינו פרויקט ללא מטרות רווח מבית עמותת נתינת לולב אשר קם במטרה לתת נופך נוסף לתהליך רכישת משלוחי המנות-</p>
            <strong>עשיית צדקה.</strong>
            <p>אנו פותחים בפניכם את האפשרות לרכוש משלוחי מנות לחג הפורים</p>
            <p>ובו בעת לתרום לעמותה שאותה תוכלו לבחור.</p>
            <strong>חלק התרומה מכלל עלות המשלוח, מוכר כתרומה לצורכי מס (לעמותה סעיף 46).</strong></>,
        mitzva: 'פרויקט "מתנות קטנות" מציע אפשרות נוספת וערכית לרכישת משלוחי המנות - הפניית כל הרווחים לצדקה, ובכך לקיים את דברי חז"ל: "מצווה גוררת מצווה"',
        whyUs: {
            kit: 'ניתן לבחור מתוך מגוון סוגי המשלוחים כפי שמופיע באתר.',
            expenses: '​אין הוצאות שכר או אחרות לחברי העמותה'
        }
    },
    en: {
        hiw: 'How it works',
        steps: {
            kit: {
                title: 'Choose a Mishloach Manot',
                paragraph: 'Choose a Mishloach Manot from a variety of different options',
            },
            associations: {
                title: 'Choose an organization you are interested in donating to',
                paragraph: `All the proceeds from the sale of the Mishloach Manot will be transferred in full to the selected association.

                You can choose to divide the donation evenly among the associations participating in the project.
                Our Association is fully volunteer based, all profits go to charity.`,
            },
            distributionStations: {
                title: `Choose a distribution station to collect your purchase`,
                paragraph: `In preparation for Purim, there will be a large number of centers around the country where the products can be received.
                * This year home delivery will not be possible due to our desire to direct most of the attention to the distribution stations.
                For your convenience, we have added a large number of distribution stations to facilitate the collection of purchases.
                
                Choose the most convenient spot for you.`,
                linkTitle: 'For the full list of distribution stations'
            },
            payment: {
                title: 'Payment',
                paragraph: `Payment will be made by credit card on a secure website.

                We do not pass on your name and details to any external party.`,
            }
        },
        kosher: <>The Mishlochey Manot at the distribution stations come completely closed, it is not possible to select or replace parts of them. If there is a problem with the products, you can contact us on the website.<br /> (The distribution station is not responsible for the Mishlochey Manot, its role is to help with the distribution only)</>,
        aboutNet: <>
            <p>In light of the success of the "Netinat Lulav" project, we decided to launch a similar project around the holiday of Purim.</p>
            <p>"Matanot Ktanot" project is a non-profit project from the "Natinat Lulav" organization, which was created with the goal of adding <strong>an extra touch of charity</strong> to the process of acquiring Mishlochey Manot.</p>
            <p>We create the possibility for you to purchase Mishlochey Manot for the Purim holiday <br /> and at the same time donate to an association of your choice.</p>
            <strong>Donations are tax deductible (according to section 46).</strong></>,
        mitzva: '"Matanot Ktanot" offers another valuable option for purchasing the Mishlochey Manot - Directing all profits to charity, thus fulfilling the words of Chazal: "A mitzvah brings another mitzvah"',
        whyUs: {
            kit: 'You may choose from the variety of types of Mishlochey Manot as shows on the website.',
            expenses: 'The Association is fully volunteer based, all profits go to charity'
        }
    }
});

export default howItWorksText;